(() => {
  const configEl = document.getElementById('lbn-offer-ladder-config');
  if (!configEl || window.LBNOffers) return;
  const config = JSON.parse(configEl.textContent);
  const params = new URLSearchParams(location.search);
  const previewDate = config.previewAllowed ? Date.parse(params.get('lbn_preview_at')) : NaN;
  const now = () => Number.isFinite(previewDate) ? previewDate : Date.now();
  const baseline = 'Free keepsake bag over $100. Free shipping over $120.';
  const activeCampaign = () => config.campaigns
    .filter(c => c.enabled !== false && now() >= Date.parse(c.from) && now() < Date.parse(c.to))
    .sort((a, b) => (b.priority || 0) - (a.priority || 0))[0];
  const supported = cart => config.country === 'AU' && (cart.currency || 'AUD') === 'AUD';
  const money = cents => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency: 'AUD', minimumFractionDigits: cents % 100 ? 2 : 0
  }).format(Math.max(0, cents) / 100);
  // total_price includes order discounts; paid accessories still qualify.
  const qualifyingTotal = cart => Math.max(0, cart.total_price - (cart.items || [])
    .filter(item => item.gift_card || item.properties?._lbn_free_gift === 'true')
    .reduce((sum, item) => sum + (item.final_line_price || 0), 0));
  const timerText = campaign => {
    if (!campaign?.timerEnabled) return '';
    const minutes = Math.max(1, Math.ceil((Date.parse(campaign.to) - now()) / 60000));
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor(minutes % 1440 / 60);
    return `Ends in ${days ? `${days}d ` : ''}${hours}h ${minutes % 60}m`;
  };
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  let lastCart;
  let request;
  let queued = false;

  function render(cart) {
    if (!supported(cart)) return false;
    lastCart = cart;
    const campaign = activeCampaign();
    const total = qualifyingTotal(cart);
    const tiers = [{ threshold: 10000, name: 'keepsake bag' }, { threshold: 12000, name: 'standard shipping' }];
    if (campaign?.gift) tiers.push({ threshold: campaign.tier === 'double' ? 20000 : 15000, name: campaign.giftName });
    const next = tiers.find(t => total < t.threshold);
    const unlocked = tiers.filter(t => total >= t.threshold).map(t => `free ${t.name}`);
    const message = `${unlocked.length ? `Unlocked: ${unlocked.join(', ')}.` : ''}${next ? ` You are ${money(next.threshold - total)} away from your free ${next.name}.` : ''}`.trim();
    const target = next?.threshold || tiers[tiers.length - 1].threshold;
    const percent = Math.min(100, Math.round(total / target * 100));
    document.querySelectorAll('free-shipping-bar').forEach(bar => {
      bar.hidden = !cart.item_count || !cart.requires_shipping;
      setText(bar.querySelector('[data-bar-message]'), message);
      const fill = bar.querySelector('.free-shipping-bar__fill');
      if (fill) fill.style.width = `${percent}%`;
      bar.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(percent));
      let timer = bar.querySelector('[data-lbn-offer-timer]');
      if (!timer) {
        timer = document.createElement('small');
        timer.dataset.lbnOfferTimer = '';
        bar.append(timer);
      }
      const countdown = campaign?.ui === 'pom-pom' ? '' : timerText(campaign);
      timer.hidden = !countdown;
      setText(timer, countdown);
    });
    renderCampaign(cart);
    return true;
  }

  function placeUi() {
    if (config.country !== 'AU' || (window.Shopify?.currency?.active || 'AUD') !== 'AUD') return;
    const campaign = activeCampaign();
    const announcement = document.querySelector('.lbn-cro-announcement a, .announcement-bar__carousel .prose, .announcement-bar p');
    if (announcement) setText(announcement, (campaign?.ui === 'pom-pom' ? baseline : campaign?.banner) || baseline);
    document.querySelectorAll('[class^="ai-marquee-text-"]').forEach(slot => {
      if (!slot.hasAttribute('data-lbn-shipping-slot') && /FREE SHIPPING ON ORDERS A\$120\+/i.test(slot.textContent)) {
        slot.setAttribute('data-lbn-shipping-slot', '');
      }
      if (slot.hasAttribute('data-lbn-shipping-slot')) setText(slot, (campaign?.ui === 'pom-pom' ? baseline : campaign?.banner) || baseline);
    });
    const productTarget = document.querySelector('product-form, .product-info .buy-buttons');
    if (productTarget && !document.querySelector('.lbn-pdp-offer-badge')) {
      const badge = document.createElement('p');
      badge.className = 'lbn-pdp-offer-badge';
      productTarget.insertAdjacentElement('afterend', badge);
    }
    document.querySelectorAll('.lbn-pdp-offer-badge').forEach(badge => setText(badge, (campaign?.ui === 'pom-pom' ? baseline : campaign?.banner) || baseline));
    renderCampaign(lastCart);
    if (lastCart) render(lastCart);
  }

  function renderCampaign(cart) {
    const campaign = activeCampaign();
    const allowed = config.country === 'AU' && (cart?.currency || window.Shopify?.currency?.active || 'AUD') === 'AUD';
    const active = allowed && campaign?.ui === 'pom-pom';
    const preview = Number.isFinite(previewDate);
    const total = cart ? qualifyingTotal(cart) : 0;
    document.querySelectorAll('[data-lbn-campaign]').forEach(panel => {
      panel.hidden = !active;
      if (!active) return;
      setText(panel.querySelector('[data-campaign-countdown]'), timerText(campaign).replace(/^Ends in /, ''));
      const qualified = total >= campaign.threshold;
      const status = panel.querySelector('[data-campaign-status]');
      const strings = config.offerStrings;
      setText(status, qualified ? strings.select : strings.remaining.replace('__AMOUNT__', money(campaign.threshold - total)));
      const demo = panel.querySelector('[data-campaign-preview]');
      const claim = panel.querySelector('[data-campaign-claim]');
      if (demo) demo.hidden = !preview || !qualified;
      if (claim) claim.hidden = preview || !qualified;
      if (claim && !claim.hidden) {
        const widget = claim.querySelector('[data-campaign-yaki]');
        const loading = claim.querySelector('[data-campaign-loading]');
        if (loading) {
          loading.hidden = Boolean(widget?.textContent.trim());
          if (!loading.dataset.started) loading.dataset.started = String(Date.now());
          if (Date.now() - Number(loading.dataset.started) > 15000) setText(loading, strings.unavailable);
        }
      }
      const link = panel.querySelector('[data-campaign-cart-link]');
      if (link && preview) {
        const url = new URL(link.href);
        url.searchParams.set('lbn_preview_at', params.get('lbn_preview_at'));
        link.href = url.pathname + url.search + url.hash;
      }
    });
  }

  async function refresh() {
    placeUi();
    if (request) { queued = true; return request; }
    request = (async () => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
        if (response.ok) render(await response.json());
      } catch (error) { console.warn('Offer messaging could not refresh.', error); }
      finally { request = null; if (queued) { queued = false; refresh(); } }
    })();
    return request;
  }

  // Yaki owns gift additions, removals and checkout pricing. This script only renders messaging.
  window.LBNOffers = { render, supported, refresh };
  ['cart:change', 'cart:refresh', 'cart-drawer:refreshed', 'cart:updated', 'discount:applied', 'shopify:section:load']
    .forEach(event => document.addEventListener(event, refresh));
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  let frame;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; placeUi(); });
  }).observe(document.body, { childList: true, subtree: true });
  setInterval(placeUi, 30000);
  refresh();
})();
